module.exports = __webpack_public_path__ + "images/mdj/members/resume/resume_end_screen/service-image-en--pc-69e862e681c86ea73fadc64f4ad6906b.png";